import { render } from "./beOverdue.vue?vue&type=template&id=5da0291b&scoped=true"
import script from "./beOverdue.vue?vue&type=script&lang=js"
export * from "./beOverdue.vue?vue&type=script&lang=js"

import "./beOverdue.vue?vue&type=style&index=0&id=5da0291b&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da0291b"]])

export default __exports__